import services from './service'; // Service Class

export default class {

    
    constructor() {
        this.service = new services();
    }

    //login
    // login(payload){
    //     let result = [];
    //     this.service.loginUser(this, payload).then(response => {
    //         if(response.body.status == 200) {
    //             let data = response.body.data;
    //             localStorage.setItem("sp_user", data.user_name); 
    //             localStorage.setItem("sp_token", data.user_session_key); //store session key here linked to session well @server
    //             localStorage.setItem("sp_token_key", data.user_token_key); 
               
    //             result["status"] = 200;
    //             result["message"] = "logged In";

    //             return result;
    //         }else{
    //             result["status"]=400;
    //             result["message"]="invalid login credentials";
    //             return result;
    //         }
    //     }).catch((err) => {
    //         result["status"]=400;
    //         result["message"]="invalid login credentials";
    //         return result;
    //     })
    // }

    //set login .... use user details to set session
    set_login(data){
        let result = [];
        localStorage.setItem("sp_user", data.user_name); 
        localStorage.setItem("sp_token", data.user_session_key); //store session key here linked to session well @server
        localStorage.setItem("sp_token_key", data.user_token_key); 
               
        result["status"]=200;
        
    }
}


// WEBPACK FOOTER //
// ./src/services/utility.js